import type { ReactNode } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useSnapshotSection } from "@/components/snapshot/snapshotSection.context";

/**
 * Builds the section's snapshot: "Rebuild" when up to date, "Update snapshot" when out of date,
 * "Build snapshot" otherwise. Disabled while the section can't be built.
 */
export const SnapshotDropzoneBuildButton = () => {
  const section = useSnapshotSection();
  const status = section.status;

  let variant: "text" | "outlined" | "contained" = "text";
  let icon: ReactNode = <LayersOutlinedIcon fontSize="small" />;
  let label = "Build snapshot";
  if (status === "building") {
    icon = (
      <CircularProgress
        color="inherit"
        size={14}
        thickness={6}
      />
    );
    label = "Building…";
  }
  else if (status === "ok") {
    icon = <RefreshIcon fontSize="small" sx={{ position: "relative", bottom: 2 }} />;
    label = "Rebuild";
  }
  else if (status === "stale") {
    label = "Update snapshot";
  }
  else if (status === "empty" && !section.canBuild) {
    variant = "text";
  }

  return (
    <Button
      disabled={!section.canBuild}
      onClick={section.startBuild}
      size="small"
      startIcon={icon}
      sx={{ whiteSpace: "nowrap" }}
      variant={variant}
    >
      {label}
    </Button>
  );
};
